

















import {
  defineComponent,
  SetupContext,
  computed
} from '@vue/composition-api'

import { TcLink } from '@telia/shared-ui-components'
import { isLinkExternal } from '@/utils/common.utils'

export interface Props {
  name: string;
  href: string;
  params: Record<string, string>;
  variant: string;
  external: boolean;
}

export default defineComponent({
  components: { TcLink },
  props: {
    href: {
      type: String
    },
    name: {
      type: String
    },
    params: {
      type: Object
    },
    variant: {
      type: String,
      default: 'stand-alone'
    }
  },
  setup (props: Props, context: SetupContext) {
    const name = props.name
    const params = props.params
    const href = props.href

    if (params && !name) {
      throw new Error('params are working only with route name, please define both name and params props in ansl-link')
    }

    const external = computed(() => {
      return href && isLinkExternal(href)
    })

    const handleRouting = () => {
      // trows exception when pushing the same path you're already on
      if (href && context.root.$route.path !== href) {
        context.root.$router.push(href)
      }

      if (name && context.root.$route.name !== name) {
        context.root.$router.push(
          {
            name: name,
            params: params
          }
        )
      }
    }

    return {
      external,
      handleRouting
    }
  }
})
